import { HttpService, resolveService } from "@reco-m/core";

export class ParkCateHttpService extends HttpService {
    constructor() {
        super("organization/parkcatalog");
    }

    postList(data: any) {
        return this.httpPost("post-list", data)
    }
}

export const parkCateService = resolveService(ParkCateHttpService);
